module.exports = {
    className: "Beacon",
    classNameLabel: "Beacon",
    limit: 10,
    showExport: false,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "uuid",
            type: "string"
        },
        {
            columnName: "major",
            type: "number"
        },
        {
            columnName: "minor",
            type: "number"
        },
        {
            columnName: "hexNamespace",
            columnLabel: "hex Namespace",
            type: "string"
        },
        {
            columnName: "hexInstance",
            columnLabel: "hex Instance",
            type: "string"
        },
        {
            columnName: "createdAt",
            type: "Date"
        },
        {
            columnName: "updatedAt",
            type: "Date"
        }
    ]
}


// WEBPACK FOOTER //
// ./components/Beacon/BeaconSchema.js